(function () {
  if (!document.body.classList.contains('sa-collection-page')) return;

  const toolbar = document.querySelector('[data-sa-coltoolbar]');
  if (toolbar) {
    const onScroll = () => {
      toolbar.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  const jumpBtn = document.querySelector('[data-sa-jump-filters]');
  if (jumpBtn) {
    jumpBtn.addEventListener('click', () => {
      const target =
        document.querySelector('.facets-mobile-wrapper') ||
        document.querySelector('.facets-block-wrapper') ||
        document.getElementById('ResultsList');
      target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
})();
